// @flow
import type {Node, Element} from 'react'
import React, {Component, Fragment} from 'react'

import Heading from 'components/ui/Heading'
import Markdown from 'components/ui/Markdown'
import Box from 'components/OrgNav/OrgNavApp/RoleContainer/Sections/ui/Box'
import ParentTip
  from 'components/OrgNav/OrgNavApp/RoleContainer/Sections/OverviewBox/Overview/ui/ParentTip'
// eslint-disable-next-line import/named
import Alert, {Severity} from 'components/ui/Alert'
import type {Alert as AlertType} from 'components/types'
import styles from './index.scss'

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6

type Props = {
  alert: ?AlertType,
  children: Node,
  className: ?string,
  description: ?string,
  error: ?string,
  title: string,
  rightButton: ?() => Node,
  withMarkupParser: boolean,
  headingLevel: HeadingLevel,
  headerClassName: string,
  ...
}

class Section extends Component<Props> {
  static defaultProps: {
  alert: null,
  className: null,
  description: null,
  error: null,
  headerClassName: string,
  headingLevel: HeadingLevel,
  rightButton: null,
  withMarkupParser: boolean,
} = {
      alert: null,
      className: null,
      description: null,
      error: null,
      rightButton: null,
      withMarkupParser: false,
      headingLevel: 2,
      headerClassName: '',
    }

  // eslint-disable-next-line class-methods-use-this
  renderError: ((error: string) => Element<"div">) = (error: string) => (
    <div className="refinery-section__error">
      <Alert
        message={error}
        severity={Severity.Danger}
      />
    </div>
  )

  renderTitle: (() => Node | string) = () => {
    if (this.props.withMarkupParser) {
      return (
        <Markdown
          disallowedTypes={['p']}
          unwrapDisallowed
          source={this.props.title}
        />
      )
    }

    return this.props.title
  }

  renderContent: (() => Node) = () => (
    <Fragment>
      {this.props.children}
      {this.props.alert && this.renderError(this.props.alert.message)}
    </Fragment>
  )

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  render: (() => Element<"div">) = () => (
    <div className={this.props.className}>
      <Box>
        <Heading
          headingLevel={this.props.headingLevel}
          spacing="xSmall"
          underlined
          rightButton={this.props.rightButton}
          className={this.props.headerClassName}
        >
          {this.renderTitle()}
          {this.props.description && <ParentTip tip={this.props.description} />}
        </Heading>
        <div className={styles.body}>
          <Box.Body>
            {this.props.error
              ? this.renderError(this.props.error)
              : this.renderContent()
            }
          </Box.Body>
        </div>
      </Box>
    </div>
  )
}

export default Section
